import axios from "axios";
import { BASE_URL } from "./api";

export async function getCompanyCells(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/company_cells/`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error
    });
}